<template>
  <div class="pa-3 pa-md-4">
    <!-- Botón Volver -->
    <v-btn @click="$router.back()" class="back-btn mb-2">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>

    <!-- Card 1: Filtros de Búsqueda -->
    <v-col cols="12" class="px-0">
      <v-card class="rounded-lg elevation-3 overflow-hidden">
        <v-toolbar height="58" color="secondary" dark flat class="px-3">
          <v-icon left>mdi-recycle-variant</v-icon>
          <span class="text-h6 font-weight-medium">Índice de Reencauche</span>
          <v-spacer></v-spacer>
          <v-tooltip left v-if="$route.query.fromDashboard">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-1 btn-circle-tooltip"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="$router.push('/home#sec-reencauche')"
              >
                <v-icon size="22" color="white">mdi-home</v-icon>
              </v-btn>
            </template>
            <span>Volver al Inicio</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-1 btn-circle-tooltip"
                icon
                dark
                target="_blank"
                :href="global.helpdesk_url + 'indice_reencauche'"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon size="25" color="amber lighten-2">mdi-help-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>¿Necesitas ayuda?</span>
          </v-tooltip>
        </v-toolbar>

        <v-card-text class="pa-4 pa-md-5">
          <div class="section-title d-flex align-center mb-3">
            <v-icon color="secondary" small class="mr-2">mdi-filter-variant</v-icon>
            <span class="text-subtitle-2 font-weight-bold text--primary">
              Filtros de Búsqueda
            </span>
          </div>

          <v-form ref="form" enctype="multipart/form-data">
            <v-row dense>
              <v-col cols="12" sm="6" md="5" class="pa-2">
                <v-text-field
                  type="text"
                  label="Cliente"
                  v-model="Cliente.razon_social"
                  hide-details="auto"
                  readonly
                  outlined
                  dense
                  class="rounded-lg bg-light"
                  prepend-inner-icon="mdi-domain"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="pa-2">
                <v-text-field
                  type="text"
                  label="RUC"
                  v-model="Cliente.ruc"
                  hide-details="auto"
                  readonly
                  outlined
                  dense
                  class="rounded-lg bg-light"
                  prepend-inner-icon="mdi-card-account-details-outline"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="pa-2">
                <v-select
                  :items="Years"
                  v-model="item.anio"
                  label="Año *"
                  outlined
                  dense
                  hide-details="auto"
                  class="rounded-lg"
                  prepend-inner-icon="mdi-calendar-range"
                  @change="filtrar"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- Loader -->
    <v-col cols="12" v-if="loader == true" class="px-0">
      <v-row justify="center" class="my-6">
        <vue-loaders name="ball-beat" color="#424242" scale="1"></vue-loaders>
      </v-row>
    </v-col>

    <!-- Card 2: Resumen KPI -->
    <v-col cols="12" class="px-0">
      <v-card class="rounded-lg elevation-3 overflow-hidden">
        <v-toolbar height="50" color="grey darken-3" dark flat class="px-3">
          <div class="d-flex align-center flex-wrap">
            <v-icon left small>mdi-chart-bell-curve-cumulative</v-icon>
            <span class="text-subtitle-1 font-weight-medium">Indicador Clave (KPI)</span>
            <v-chip
              v-if="mesSeleccionado !== null"
              color="primary"
              dark
              small
              class="ml-3 font-weight-bold elevation-1"
              close
              @click:close="seleccionarMes(null)"
            >
              <v-icon left x-small>mdi-calendar-month</v-icon>
              Mes: {{ nombreMesKpi }}
            </v-chip>
            <v-chip
              v-else
              small
              color="grey lighten-2"
              class="ml-3 font-weight-bold grey--text text--darken-3 text-caption"
            >
              Promedio Anual
            </v-chip>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            v-if="mesSeleccionado !== null"
            x-small
            text
            dark
            class="text-none font-weight-bold"
            @click="seleccionarMes(null)"
          >
            <v-icon left x-small>mdi-refresh</v-icon> Ver Prom. Anual
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4">
          <div class="kpi-formula-container pa-4 rounded-lg">
            <div class="d-flex align-center justify-center text-body-2 flex-nowrap overflow-x-auto">
              <!-- Título -->
              <div
                class="text-center font-weight-bold grey--text text--darken-3 text-subtitle-2 px-3 py-2 bg-white rounded-lg elevation-1 border-subtle"
                style="line-height: 1.2"
              >
                Índice de<br />reencauche
              </div>

              <span class="mx-3 font-weight-bold text-grey-darken-2 text-h5">=</span>

              <!-- Fracción conceptual -->
              <div class="d-inline-flex flex-column align-center px-3 py-2 bg-white rounded-lg elevation-1 border-subtle">
                <span class="pb-1 border-bottom-fraction px-2 font-weight-medium text-caption text--secondary">
                  Total de neumáticos reencauchados
                </span>
                <span class="pt-1 px-2 font-weight-medium text-caption text--secondary">
                  Total de neumáticos
                </span>
              </div>

              <template
                v-if="
                  datosKpi &&
                  (datosKpi.total_reencauchados !== undefined ||
                    datosKpi.indice_reencauche !== undefined)
                "
              >
                <span class="mx-3 font-weight-bold text-grey-darken-2 text-h5">=</span>

                <!-- Fracción de valores reales -->
                <div class="d-inline-flex flex-column align-center px-3 py-2 bg-white rounded-lg elevation-1 border-subtle">
                  <span class="pb-1 border-bottom-fraction px-2 font-weight-bold primary--text text-subtitle-2 font-mono">
                    {{ Number(datosKpi.total_reencauchados || 0).toLocaleString("es-PE") }}
                  </span>
                  <span class="pt-1 px-2 font-weight-bold text--primary text-subtitle-2 font-mono">
                    {{ Number(datosKpi.total_neumaticos || 0).toLocaleString("es-PE") }}
                  </span>
                </div>

                <template
                  v-if="
                    datosKpi.indice_reencauche !== undefined &&
                    datosKpi.indice_reencauche !== ''
                  "
                >
                  <span class="mx-3 font-weight-bold text-grey-darken-2 text-h5">=</span>

                  <!-- Resultado -->
                  <div class="kpi-result-chip px-4 py-2 rounded-lg elevation-2 font-mono">
                    <span
                      class="text-caption text-uppercase font-weight-bold opacity-80 d-block"
                      style="font-size: 0.7rem !important; letter-spacing: 0.5px"
                    >
                      Índice Calculado
                    </span>
                    <span class="text-h6 font-weight-black">
                      {{ (datosKpi.indice_reencauche * 100).toFixed(2) }}%
                    </span>
                  </div>
                </template>
              </template>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- Card 3: Tabla Matriz de Indicadores -->
    <v-col cols="12" class="px-0">
      <v-card class="rounded-lg elevation-3 overflow-hidden">
        <v-toolbar height="54" color="secondary" dark flat class="px-3">
          <v-icon left>mdi-table-clock</v-icon>
          <span class="text-subtitle-1 font-weight-medium">
            Año: {{ annio || "-" }}
          </span>
          <v-chip
            small
            color="white"
            text-color="secondary"
            class="font-weight-bold ml-3 px-3 elevation-1"
          >
            Índice de Reencauche
          </v-chip>
          <v-spacer></v-spacer>
          <v-btn
            small
            outlined
            dark
            class="rounded-lg text-none mr-3"
            @click="mostrarMensual = !mostrarMensual"
          >
            <v-icon left small>{{ mostrarMensual ? "mdi-eye" : "mdi-chart-bar" }}</v-icon>
            {{ mostrarMensual ? "Ver Prom. Anual" : "Ver Detalle Mensual" }}
          </v-btn>
          <v-btn
            color="success"
            dark
            height="36"
            class="px-4 font-weight-bold elevation-1 text-none rounded-lg"
            @click="exportarAexcel"
          >
            <v-icon left small>mdi-file-excel-box</v-icon>
            Exportar Excel
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4">
          <div
            class="table-responsive-wrapper"
            :class="{ 'scroll-active': hasScroll, 'is-dragging': isDragging }"
            ref="tableContainer"
            @mousedown="startDrag"
            @mouseleave="stopDrag"
            @mouseup="stopDrag"
            @mousemove="doDrag"
          >
            <table
              class="matriz-table"
              :class="{
                'tabla-mensual': mostrarMensual,
                'tabla-resumen': !mostrarMensual,
              }"
              id="table"
            >
              <thead>
                <tr class="header-dark">
                  <th
                    class="table-border texto-cen pa-2"
                    style="width: 10%"
                    :rowspan="mostrarMensual ? 2 : 1"
                  >
                    Proceso
                  </th>
                  <th
                    class="table-border texto-cen pa-2"
                    style="width: 15%"
                    :rowspan="mostrarMensual ? 2 : 1"
                  >
                    Indicador
                  </th>
                  <th
                    class="table-border texto-cen pa-2"
                    style="width: 25%"
                    :rowspan="mostrarMensual ? 2 : 1"
                  >
                    Criterio de aceptación
                  </th>
                  <template v-if="mostrarMensual">
                    <th
                      class="table-border texto-cen pa-2"
                      :colspan="meses.length"
                    >
                      Meses
                    </th>
                  </template>
                  <th
                    class="table-border texto-cen pa-2 th-clickable"
                    style="width: 12%"
                    :rowspan="mostrarMensual ? 2 : 1"
                    :class="{ 'header-seleccionado': mesSeleccionado === null }"
                    @click="seleccionarMes(null)"
                  >
                    Prom. Anual
                  </th>
                </tr>
                <tr class="header-sub" v-if="mostrarMensual">
                  <th
                    class="table-border texto-cen pa-2 th-clickable"
                    style="width: 4%"
                    v-for="(item, index) in meses"
                    :key="index"
                    :class="{ 'header-seleccionado': mesSeleccionado === index }"
                    @click="seleccionarMes(index)"
                  >
                    {{ item.substring(0, 3) }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="IndicesReencauchePorMes.length > 0" class="data-row">
                  <td class="table-border texto-cen pa-2 font-weight-bold grey-bg">KPI</td>
                  <td class="table-border texto-cen pa-2 font-weight-medium">Índice de reencauche</td>
                  <td
                    class="table-border pa-2"
                    v-if="
                      IReencauche.criterio_superior != 0 &&
                      IReencauche.tolerable_inferior != 0 &&
                      IReencauche.tolerable_superior != 0
                    "
                  >
                    <div class="criterion-badge criterion-success mb-1">
                      <span class="criterion-dot"></span>
                      <span>Objetivo &gt; {{ (IReencauche.criterio_superior * 100).toFixed(2) }}%</span>
                    </div>
                    <div class="criterion-badge criterion-warning mb-1">
                      <span class="criterion-dot"></span>
                      <span>Tolerable [{{ (IReencauche.tolerable_inferior * 100).toFixed(2) }}% - {{ (IReencauche.tolerable_superior * 100).toFixed(2) }}%]</span>
                    </div>
                    <div class="criterion-badge criterion-danger">
                      <span class="criterion-dot"></span>
                      <span>Deficiente &lt; {{ (IReencauche.tolerable_inferior * 100).toFixed(2) }}%</span>
                    </div>
                  </td>
                  <td class="table-border texto-cen pa-2 text-caption text--secondary" v-else>
                    No cuenta con un criterio de Aceptación
                  </td>
                  <template v-if="mostrarMensual">
                    <td
                      v-for="(item, index) in IndicesReencauchePorMes"
                      :key="index"
                      :class="[
                        pintarIndice(item),
                        { 'celda-seleccionada': mesSeleccionado === index },
                      ]"
                      style="cursor: pointer"
                      @click="seleccionarMes(index)"
                    >
                      {{ valorTd(item) }}
                    </td>
                  </template>
                  <td
                    :class="[
                      pintarIndice(obtenerPromedioAnual()),
                      { 'celda-seleccionada': mesSeleccionado === null },
                    ]"
                    style="cursor: pointer"
                    @click="seleccionarMes(null)"
                  >
                    {{
                      valorTd(obtenerPromedioAnual()) !== ""
                        ? valorTd(obtenerPromedioAnual())
                        : "-"
                    }}
                  </td>
                </tr>
                <tr v-else>
                  <td :colspan="obtenerColspan()" class="table-border texto-cen pa-6 text--secondary">
                    <v-icon size="32" color="grey lighten-1" class="d-block mx-auto mb-2">mdi-database-off-outline</v-icon>
                    <span>No se registraron los Indicadores de Reencauche</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- Card 4: Gráfico Estadístico -->
    <v-col cols="12" class="px-0">
      <v-card class="rounded-lg elevation-3 overflow-hidden">
        <v-toolbar height="50" color="grey darken-3" dark flat class="px-3">
          <v-icon left small>mdi-chart-bar</v-icon>
          <span class="text-subtitle-1 font-weight-medium">Gráfico Estadístico de Índice de Reencauche</span>
        </v-toolbar>
        <v-card-text class="pa-4">
          <GraficoBar
            Title="Índice de reencauche"
            Labelsdataset="Índice de reencauche(%)"
            Labelscale_x="Meses"
            Labelscale_y="Porcentaje de reencauche (%)"
            IdGrafico="graficoreencauche"
            :Labels="Labels"
            :DatosGrafico="DatosGrafico"
            :SelectedIndex="mesSeleccionado"
            @click-bar="seleccionarMes"
            v-if="mostrarGrafico == true"
          ></GraficoBar>
        </v-card-text>
      </v-card>
    </v-col>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import GraficoBar from "../components/GraficoBar.vue";
import { axios2 as axios } from "@/interceptor/useApi";
import global from "../global";
import moment from "moment";

export default {
  components: {
    GraficoBar,
  },
  data() {
    return {
      global: global,
      item: {},
      annio: "",
      mesSeleccionado: null,
      mostrarMensual: false,
      meses: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      loader: false,
      DatosGrafico: [],
      Labels: [],
      mostrarGrafico: false,
      isDragging: false,
      startX: 0,
      startY: 0,
      scrollLeft: 0,
      scrollTop: 0,
      hasScroll: false,
    };
  },
  mounted() {
    this.checkScroll();
    window.addEventListener("resize", this.checkScroll);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScroll);
  },
  updated() {
    this.checkScroll();
  },
  watch: {
    mostrarMensual() {
      this.checkScroll();
    },
    IndicesReencauchePorMes() {
      this.checkScroll();
    },
  },
  computed: {
    ...mapState("cliente", ["Cliente"]),
    ...mapState("reporteconsolidado", ["Years"]),
    ...mapState("indicadores", [
      "IReencauche",
      "IndicesReencauchePorMes",
      "DatosTotalesAnualReencauche",
      "DatosTotalesMensualReencauche",
    ]),
    datosKpi() {
      if (this.mesSeleccionado !== null && this.mesSeleccionado !== undefined) {
        const mesObj = this.DatosTotalesMensualReencauche.find(
          (item) => item.mes === this.mesSeleccionado + 1,
        );
        if (mesObj) {
          return mesObj;
        }
      }
      return this.DatosTotalesAnualReencauche || {};
    },
    nombreMesKpi() {
      if (this.mesSeleccionado !== null && this.mesSeleccionado !== undefined) {
        return this.meses[this.mesSeleccionado];
      }
      return "Prom. Anual";
    },
  },
  methods: {
    ...mapActions("reporteconsolidado", ["cargarAnios"]),
    ...mapActions("indicadores", ["reporteIndiceReencauche"]),

    seleccionarMes(index) {
      if (index === null || index === undefined) {
        this.mesSeleccionado = null;
      } else if (this.mesSeleccionado === index) {
        this.mesSeleccionado = null;
      } else {
        this.mesSeleccionado = index;
      }
    },

    checkScroll: function () {
      this.$nextTick(() => {
        const el = this.$refs.tableContainer;
        if (el) {
          this.hasScroll =
            el.scrollWidth > el.clientWidth ||
            el.scrollHeight > el.clientHeight;
        }
      });
    },

    startDrag: function (e) {
      const el = this.$refs.tableContainer;
      if (!el || !this.hasScroll) return;
      this.isDragging = true;
      this.startX = e.pageX - el.offsetLeft;
      this.startY = e.pageY - el.offsetTop;
      this.scrollLeft = el.scrollLeft;
      this.scrollTop = el.scrollTop;
    },

    stopDrag: function () {
      this.isDragging = false;
    },

    doDrag: function (e) {
      if (!this.isDragging) return;
      e.preventDefault();
      const el = this.$refs.tableContainer;
      if (!el) return;
      const x = e.pageX - el.offsetLeft;
      const y = e.pageY - el.offsetTop;
      const walkX = (x - this.startX) * 1.5;
      const walkY = (y - this.startY) * 1.5;
      el.scrollLeft = this.scrollLeft - walkX;
      el.scrollTop = this.scrollTop - walkY;
    },

    obtenerPromedioAnual: function () {
      if (
        this.DatosTotalesAnualReencauche &&
        this.DatosTotalesAnualReencauche.indice_reencauche !== undefined &&
        this.DatosTotalesAnualReencauche.indice_reencauche !== ""
      ) {
        return this.DatosTotalesAnualReencauche.indice_reencauche;
      }
      let suma = 0;
      let count = 0;
      this.IndicesReencauchePorMes.forEach((element) => {
        if (element !== null && element !== undefined && element !== "") {
          let num = parseFloat(element);
          if (!isNaN(num)) {
            suma += num;
            count++;
          }
        }
      });
      if (count > 0) {
        return suma / count;
      }
      return null;
    },

    filtrar: async function () {
      this.loader = true;
      this.mesSeleccionado = null;
      this.mostrarGrafico = false;
      this.annio = this.item.anio;
      await this.reporteIndiceReencauche(this.item.anio);
      this.Labels = this.meses;
      this.DatosGrafico = [];
      this.IndicesReencauchePorMes.forEach((element) => {
        this.DatosGrafico.push((element * 100).toFixed(2));
      });
      this.mostrarGrafico = true;
      this.loader = false;
    },

    // exportarAexcel: function(){
    //   location.href =
    //     global.ruta_api + "excel/reporteindicereencauche?" +
    //     global._json_to_query_string({
    //       id_cliente: localStorage.getItem("idcliente"),
    //       id_usuario: localStorage.getItem("id"),
    //       year: this.annio
    //     });
    // },

    exportarAexcel: function () {
      axios
        .get(
          "excel/reporteindicereencauche?" +
            global._json_to_query_string({
              id_cliente: localStorage.getItem("idcliente"),
              id_usuario: localStorage.getItem("id"),
              year: this.annio,
            }),
          {
            responseType: "blob", // Importante: especificar que la respuesta es un blob
          },
        )
        .then((response) => {
          console.log("response", response);
          // Procesar y descargar el archivo después de que la promesa se resuelva
          const contentType = response.headers["content-type"];
          let fileName = response.headers["nombre-archivo"] || "archivo.xlsx";

          if (
            contentType ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            const fileBlob = new Blob([response.data], { type: contentType });
            const downloadLink = document.createElement("a");
            downloadLink.href = URL.createObjectURL(fileBlob);
            downloadLink.download = fileName;
            document.body.appendChild(downloadLink); // Agregar al DOM
            downloadLink.click();
            document.body.removeChild(downloadLink); // Limpiar el DOM
            URL.revokeObjectURL(downloadLink.href); // Liberar memoria
          } else {
            throw new Error("La respuesta no es un archivo Excel");
          }
        })
        .catch((error) => {
          this.errorMessage = error.response?.data || error.message;
          console.error("error!", error);
        });
    },

    pintarIndice: function (item) {
      let pintar = "table-border texto-cen pa-2 font-mono";
      if (item !== "" && item !== null && item !== undefined) {
        if (
          item >= this.IReencauche.tolerable_inferior &&
          item <= this.IReencauche.tolerable_superior
        )
          pintar = "table-border texto-cen pa-2 font-mono bg-celda-amarilla";
        if (item > this.IReencauche.criterio_superior)
          pintar = "table-border texto-cen pa-2 font-mono bg-celda-verde";
        if (item < this.IReencauche.criterio_inferior)
          pintar = "table-border texto-cen pa-2 font-mono bg-celda-roja";
      }
      return pintar;
    },

    valorTd: function (item) {
      if (item !== "" && item !== null && item !== undefined) {
        item = (item * 100).toFixed(2) + "%";
      } else {
        item = "";
      }
      return item;
    },

    obtenerColspan: function () {
      let cols = 4;
      if (this.mostrarMensual && this.meses) {
        cols += this.meses.length;
      }
      return cols;
    },
  },
  created() {
    this.cargarAnios();
    let fecha = moment(new Date(), "YYYY-MM-DD"); //2021-05-20 //YYYY-MM-DD
    this.annio = fecha.format("YYYY");
    this.item.anio = fecha.format("YYYY");
    this.filtrar();
  },
};
</script>

<style scoped>
.matriz-table {
  width: 100%;
  border-collapse: collapse;
}

.table-border {
  border: 1px solid #e2e8f0;
}

.texto-cen {
  text-align: center;
}

.header-dark,
.header-dark th {
  background-color: #424242 !important;
  color: #ffffff !important;
  font-size: 0.8rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  border: 1px solid #525252 !important;
  padding: 10px 8px !important;
  white-space: nowrap;
}

.header-sub,
.header-sub th {
  background-color: #333333 !important;
  color: #ffffff !important;
  font-size: 0.78rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  border: 1px solid #4a4a4a !important;
  padding: 6px 4px !important;
}

.th-clickable {
  cursor: pointer !important;
  transition: background-color 0.15s ease-in-out !important;
}

.th-clickable:hover {
  background-color: #212121 !important;
}

.header-seleccionado {
  background-color: #1976d2 !important;
  color: white !important;
  border-color: #1976d2 !important;
}

.celda-seleccionada {
  box-shadow: inset 0 0 0 3px #1976d2 !important;
  border-color: #1976d2 !important;
  font-weight: bold;
}

.criterion-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.76rem;
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: 0.2px;
  text-align: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
}

.criterion-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 6px;
  flex-shrink: 0;
  background-color: #ffffff !important;
}

.criterion-success {
  background-color: #16a34a !important;
  color: #ffffff !important;
  border: 1px solid #15803d !important;
}

.criterion-warning {
  background-color: #f59e0b !important;
  color: #ffffff !important;
  border: 1px solid #d97706 !important;
}

.criterion-danger {
  background-color: #dc2626 !important;
  color: #ffffff !important;
  border: 1px solid #b91c1c !important;
}

.grey-bg {
  background-color: #f8fafc;
  color: #334155;
}

.data-row:hover td {
  background-color: #f1f5f9;
}

.bg-celda-amarilla {
  background-color: #fde047 !important;
  color: #713f12 !important;
  font-weight: 700;
}

.bg-celda-verde {
  background-color: #86efac !important;
  color: #064e3b !important;
  font-weight: 700;
}

.bg-celda-roja {
  background-color: #fca5a5 !important;
  color: #7f1d1d !important;
  font-weight: 700;
}

#table.tabla-mensual {
  min-width: 1000px;
  width: 100%;
}

#table.tabla-resumen {
  width: 100%;
}

.table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive-wrapper.scroll-active {
  cursor: grab;
}

.table-responsive-wrapper.is-dragging {
  cursor: grabbing !important;
  user-select: none;
}

.table-responsive-wrapper::-webkit-scrollbar {
  height: 6px;
}

.table-responsive-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.section-title {
  border-left: 3px solid #424242;
  padding-left: 8px;
  margin-bottom: 12px;
}

.bg-light {
  background-color: #f8fafc !important;
}

.kpi-formula-container {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.border-subtle {
  border: 1px solid #e2e8f0;
}

.border-bottom-fraction {
  border-bottom: 2px solid #cbd5e1;
}

.kpi-result-chip {
  background: linear-gradient(135deg, #1e293b, #0f172a);
  color: #ffffff;
  min-width: 140px;
  text-align: center;
}

.font-mono {
  font-family: monospace, "Courier New", Courier !important;
  letter-spacing: 0.2px;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}
</style>
